import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Col, Row, message } from 'antd';
import { OrganisationContainer } from './styles';
import { AppStoreContext } from '../../context/appStoreContext';
import { licenseDetails, organisation } from '../../utils/services/onPremAPI';
import Loader from '../../components/Loader';
import OrganizationSetupPage from './OrganizationSetupPage';
import Authentication from '.';
import SSOLogin, { EmbedSsoLogin } from './SSOLogin';
import LicenseExpiredPage from './LicenseExpiredPage';
import i18n from '../../i18n';
import { withTranslation } from 'react-i18next';
import { ENTERPRISE as trans } from './translationValues';
import URL, { SSO_REDIRECT_URL } from '../../utils/helper';
import { getPkceAuthClient } from '../../utils/authHelper';

const NAMESPACES = ['ENTERPRISE'];

const Enterprise = props => {
  const { t, ssoRedirect = false, embedRedirect = false } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [showSignIn, setShowSignIn] = useState(false);
  const [isLicenseExpired, setIsLicenseExpired] = useState(false);

  const { setAuthClient, setSSOSetup } = useContext(AppStoreContext);

  useEffect(() => {
    (async () => {
      i18n.changeLanguage(navigator.language || navigator.userLanguage);
      
      const response = await organisation();
      /*response.ssoEnabled = true;
      response.jacksonUrl = 'https://kubedev03.tekclansolutions.com';
      response.tenantName = 'xerox2';
      response.product = 'PDS';*/
      if (response) {
        setSSOSetup(response);
        if (response.ssoEnabled) {
            setAuthClient(getPkceAuthClient(response, SSO_REDIRECT_URL));
        }

        if (response.isOrganizationOnboarded) {
            if (response.licenseStatus !== 0) {
              setIsLicenseExpired(true);
            }
            setShowSignIn(true);
        } else {
          setShowSignIn(false); // Showing onboarding form
        }
      } else {
        message.error(t(trans.ORGANIZATION_API_FAILED_ERROR_MESSAGE.key, trans.ORGANIZATION_API_FAILED_ERROR_MESSAGE.value));
      }
      setIsLoading(false);
    })();
  }, []);

  return (
    <OrganisationContainer>
      {isLoading ? (
        <Loader />
      ) : isLicenseExpired ? (
        <LicenseExpiredPage />
      ) : !showSignIn ? (
        <Row>
          <Col xs={0} sm={0} md={0} lg={12}>
            <div className="left-side"></div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} className="right-side">
            <OrganizationSetupPage setShowSignIn={setShowSignIn} />
          </Col>
        </Row>
      ) : ssoRedirect ? (
        <SSOLogin />
      ) : embedRedirect ? (
        <EmbedSsoLogin/>
      ) : (
        <Authentication visiblePage={window.location.pathname.toLowerCase() === '/ldap'
          ? 'ldap'
          : window.location.pathname.toLowerCase() === '/redirect' ? 'redirect' : 'login'} />
      )}
    </OrganisationContainer>
  );
};

export default withTranslation(NAMESPACES)(Enterprise);
